// src/infrastructure/config/index.js
// const apiBaseUrl = localStorage.getItem('apiurl') || 'https://api.smartbustw.com/api';
const apiBaseUrl = 'https://api.smartbustw.com';
const config = {
    apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
};

export default config;